import { OpenExternalUrlAction } from "block-system/types";
import { sanitizeUrl } from "lib/hooks/useSafeUrl";

export function openExternalUrl(externalUrlAction: OpenExternalUrlAction) {
  const url = sanitizeUrl(externalUrlAction.config.url).sanitizedUrl;
  const target =
    externalUrlAction.config.opensInNewTab === false ? "_self" : "_blank";
  window.open(url, target);
}
